var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlestick = function SvgCandlestick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.25 3.25V1h1.5v2.25zM3.25 19v-6.25h1.5V19z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.75 3.25h4.5v9.5h-4.5zm1.5 1.5v6.5h1.5v-6.5z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.75 3.25h4.5v9.5h-4.5zm1.5 1.5v6.5h1.5v-6.5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.75 17.75V19h-1.5v-1.25zM10.75 1v11.25h-1.5V1z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.25 17.75h-4.5v-5.5h4.5zm-1.5-1.5v-2.5h-1.5v2.5z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.25 4.25V1h1.5v3.25zM15.25 19v-3.25h1.5V19z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.75 4.25h4.5v11.5h-4.5zm1.5 1.5v8.5h1.5v-8.5z",
    clipRule: "evenodd"
  })));
};
export { SvgCandlestick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMjUgMy4yNUwzLjI1IDFMNC43NSAxTDQuNzUgMy4yNUgzLjI1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMjUgMTlWMTIuNzVMNC43NSAxMi43NVYxOUgzLjI1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjc1IDMuMjVINi4yNVYxMi43NUgxLjc1VjMuMjVaTTMuMjUgNC43NVYxMS4yNUg0Ljc1VjQuNzVIMy4yNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS43NSAzLjI1SDYuMjVWMTIuNzVIMS43NVYzLjI1Wk0zLjI1IDQuNzVWMTEuMjVINC43NVY0Ljc1SDMuMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBvcGFjaXR5PSIwLjUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNzUgMTcuNzVWMTlIOS4yNUw5LjI1IDE3Ljc1TDEwLjc1IDE3Ljc1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjc1IDFMMTAuNzUgMTIuMjVIOS4yNUw5LjI1IDFMMTAuNzUgMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMjUgMTcuNzVMNy43NSAxNy43NUw3Ljc1IDEyLjI1TDEyLjI1IDEyLjI1TDEyLjI1IDE3Ljc1Wk0xMC43NSAxNi4yNUwxMC43NSAxMy43NUw5LjI1IDEzLjc1TDkuMjUgMTYuMjVMMTAuNzUgMTYuMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBvcGFjaXR5PSIwLjUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuMjUgNC4yNUwxNS4yNSAxTDE2Ljc1IDFMMTYuNzUgNC4yNUgxNS4yNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4yNSAxOUwxNS4yNSAxNS43NUwxNi43NSAxNS43NUwxNi43NSAxOUgxNS4yNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNzUgNC4yNUgxOC4yNVYxNS43NUgxMy43NVY0LjI1Wk0xNS4yNSA1Ljc1VjE0LjI1SDE2Ljc1VjUuNzVIMTUuMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";